import React, { Component } from "react";
import renderHTML from "react-render-html";
import { t } from "react-multi-lang";
import { fetchLegalDocument } from "./legalApi";

/**
 * Dynamic public legal document page.
 *
 * Renders any published document by slug — used by /legal/:slug and by the
 * fixed /privacy-policy and /terms routes (which pass a `slug` prop). The text
 * is fetched from the backend (source of truth) and is sanitized server-side;
 * NO legal copy is hardcoded in React.
 */
class LegalDocumentPage extends Component {
  state = {
    data: null,
    loading: true,
    notFound: false,
  };

  componentDidMount() {
    this.load(this.resolveSlug(this.props));
  }

  componentDidUpdate(prevProps) {
    const prev = this.resolveSlug(prevProps);
    const next = this.resolveSlug(this.props);
    if (prev !== next) {
      this.load(next);
    }
  }

  resolveSlug(props) {
    if (props.slug) {
      return props.slug;
    }
    return props.match && props.match.params ? props.match.params.slug : null;
  }

  load = (slug) => {
    if (!slug) {
      this.setState({ loading: false, data: null, notFound: true });
      return;
    }
    this.setState({ loading: true, notFound: false });
    fetchLegalDocument(slug)
      .then((data) => {
        if (this.resolveSlug(this.props) !== slug) {
          return;
        }
        if (data) {
          this.setState({ loading: false, data: data, notFound: false });
        } else {
          this.setState({ loading: false, data: null, notFound: true });
        }
      })
      .catch(() => {
        if (this.resolveSlug(this.props) !== slug) {
          return;
        }
        this.setState({ loading: false, data: null, notFound: true });
      });
  };

  renderMeta(data) {
    const parts = [];
    if (data.version) {
      parts.push("Version " + data.version);
    }
    if (data.effective_at) {
      parts.push("Effective " + String(data.effective_at).substring(0, 10));
    } else if (data.published_at) {
      parts.push("Published " + String(data.published_at).substring(0, 10));
    }
    if (!parts.length) {
      return null;
    }
    return <p className="static-meta text-muted">{parts.join(" \u00b7 ")}</p>;
  }

  render() {
    const { loading, data, notFound } = this.state;

    return (
      <div className="top-bottom-spacing">
        <div className="">
          <div className="static-head">
            <h1>{loading ? t("loading") : data ? data.title : t("loading")}</h1>
          </div>
          <div className="static-content">
            {loading ? (
              t("loading")
            ) : notFound || !data ? (
              <p>{t("no_data_found") || "This document is not available."}</p>
            ) : (
              <div>
                {this.renderMeta(data)}
                {data.content ? renderHTML(data.content) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default LegalDocumentPage;
